import { useEffect, useState } from "react";
import { api, puede, type Paciente } from "../api.ts";
import type { OpcionesSonrisa } from "../../../dominio/src/index.ts";
import { AvisoError, useAccion } from "../pantallas/comun.tsx";
import { EnviarWhatsApp } from "./EnviarWhatsApp.tsx";
import { GuardarPdf } from "./GuardarPdf.tsx";

/**
 * Los diseños de sonrisa con puntos que se hicieron antes de existir «Sonrisa con IA» (ya no se pueden crear): se conservan para guardar su PDF,
 * enviarlo por WhatsApp o quitarlos. Si el paciente no tiene ninguno, no se muestra nada.
 */
interface DisenoGuardado { id: string; creado: string; por: string; opciones: OpcionesSonrisa }

/** Los diseños de sonrisa ya guardados del paciente: guardar el PDF, enviarlo por WhatsApp o quitarlo (queda en la auditoría). */
export function DisenosSonrisaGuardados({ paciente }: { paciente: Paciente }) {
  const [lista, setLista] = useState<DisenoGuardado[]>([]);
  const a = useAccion();
  const escribe = puede("clinico:escribir");
  const cargar = () => api<DisenoGuardado[]>("GET", `/api/pacientes/${paciente.id}/disenos-sonrisa`).then(setLista).catch(() => setLista([]));
  useEffect(() => { cargar(); }, [paciente.id]);
  if (!lista.length) return null;
  const fecha = (iso: string) => new Date(iso).toLocaleDateString("es-EC", { day: "numeric", month: "short", year: "numeric" });
  return (
    <div className="card" style={{ boxShadow: "none" }}>
      <h3 style={{ margin: 0 }}>Diseños de sonrisa</h3>
      <ul className="lista-abonos">
        {lista.map((d) => (
          <li key={d.id}>
            <div className="fila" style={{ justifyContent: "space-between", flexWrap: "wrap", gap: 6 }}>
              <span>{fecha(d.creado)} · {d.opciones.metodo === "aurea" ? "Proporción áurea" : `RED ${Math.round(d.opciones.red * 100)} %`} · dientes {d.opciones.forma} · {d.por}</span>
              <span className="fila" style={{ gap: 6, flexWrap: "wrap" }}>
                <GuardarPdf tipo="sonrisa" id={d.id} nombre={`Diseno-de-sonrisa-${paciente.apellidos || paciente.nombres}`} />
                <EnviarWhatsApp tipo="sonrisa" id={d.id} />
                {escribe && <button className="btn chico peligro" onClick={async () => { if (confirm("¿Quitar este diseño de sonrisa? Queda registrado en la auditoría; la foto del diseño sigue en la galería.")) { await a.correr(() => api("DELETE", `/api/disenos-sonrisa/${d.id}`)); cargar(); } }}>Quitar</button>}
              </span>
            </div>
          </li>
        ))}
      </ul>
      <AvisoError error={a.error} />
    </div>
  );
}
